import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaTools,
  FaShoppingCart,
  FaRocket,
  FaShieldAlt,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const ScalableEcommerceDevelopmentInAlBarsha = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Scalable E-commerce Development in Al Barsha" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Grow Without Limits</Subheading>}
        heading={
          <Heading>
            Scalable <span tw="text-primary-500">E-commerce Development</span>{" "}
            in Al Barsha
          </Heading>
        }
        description={
          <Description>
            MilaajBrandset offers scalable e-commerce development in **Al
            Barsha**, building flexible online stores that grow with your
            business, ensuring performance and reliability at any scale.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60", // E-commerce dashboard
          "https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60", // Business growth chart
          "https://images.unsplash.com/photo-1573164574572-cb89e39749b4?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60", // Dubai skyline
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Scale Your Store"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Scalability Matters</Subheading>}
        heading="Future-Proof E-commerce Solutions"
        description="Our scalable stores support your growth seamlessly."
        cards={[
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "High Performance",
            description: "Handle traffic spikes with ease.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Flexible Features",
            description: "Add functionality as you grow.",
          },
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "Cloud Integration",
            description: "Leverage AWS, Azure, or Google Cloud.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Secure Scaling",
            description: "Grow without compromising safety.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Cross-Device Ready",
            description: "Scalable on mobile and desktop.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Al Barsha Experts",
            description: "Local scalability specialists.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Build</Subheading>}
        heading="Our Scalable E-commerce Development Process"
        description={
          <Description>
            We create stores that grow with you:
            <ul tw="mt-4 list-disc pl-6">
              <li>Planning: Define scalability goals.</li>
              <li>Architecture: Design modular, cloud-ready systems.</li>
              <li>Development: Build with scalable frameworks.</li>
              <li>Testing: Stress-test for peak performance.</li>
              <li>Launch: Deploy a future-proof store.</li>
              <li>Support: Optimize as your business expands.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60", // Team planning
          "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60", // Business strategy
          "https://images.unsplash.com/photo-1531973576160-7125cd663d86?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60", // Dubai business district
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Our Achievements</Subheading>}
        heading="Scalable E-commerce Success in Al Barsha"
        description="Our flexible stores power growth."
        cards={[
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Traffic Handling",
            description: "50% better peak performance.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Revenue Growth",
            description: "30% sales increase post-scaling.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Confidence",
            description: "95% satisfaction rate.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Grow?</Subheading>}
        heading="Scalable E-commerce Development in Al Barsha"
        description={
          <Description>
            MilaajBrandset provides scalable e-commerce development in Al
            Barsha, building stores that evolve with your business. Contact us
            to future-proof your online presence today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60", // Mobile e-commerce
          "https://images.unsplash.com/photo-1526458179558-6c36b2399722?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60", // Developer coding
          "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60", // Dubai modern architecture
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
